import styled from 'styled-components';
import { BasketPriceDetailsStyled } from '../BasketPriceDetailsStyled';

export const BasketPriceDetailsAP = styled(BasketPriceDetailsStyled)``;
